import { render, staticRenderFns } from "./brandConceptPhone.vue?vue&type=template&id=291ef227&scoped=true"
import script from "./brandConceptPhone.vue?vue&type=script&lang=js"
export * from "./brandConceptPhone.vue?vue&type=script&lang=js"
import style0 from "./brandConceptPhone.vue?vue&type=style&index=0&id=291ef227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291ef227",
  null
  
)

export default component.exports